import { safeGet, safeSet, safeRemove } from './safeStorage';

/**
 * Tracking de "fez check-in hoje?" pra mecânicas de retenção.
 *
 * Usado por:
 *  - Daily Bonus B (épico/lendário só desbloqueia depois de check-in)
 *  - Streak warning visual (futuro)
 *
 * Por que localStorage (e não Supabase profile.lastCheckinDate):
 *  - O check-in já mexe no profile, então adicionar campo lá obriga
 *    migration SQL. Pra MVP, o localStorage flag é suficiente.
 *  - Trade-off: user limpa storage → "perde" o status de check-in do
 *    dia (mas o check-in em si está salvo no Supabase). Bonus extra
 *    fica indisponível até próximo check-in. Aceitável pra beta.
 *
 * Quando migrar pro Supabase: adicionar `users.last_checkin_date`, ler
 * direto do profile no `useDailyBonus` em vez desse helper.
 */

const KEY = '@sixpass:last-checkin-date';

function todayLocalISO(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(
    d.getDate(),
  ).padStart(2, '0')}`;
}

/**
 * Marca que o usuário fez um check-in hoje. Idempotente.
 * Chamar IMEDIATAMENTE após check-in bem-sucedido (após Supabase confirmar).
 */
export function markCheckinDoneToday(): void {
  safeSet(KEY, todayLocalISO());
  // Dispara evento custom pra hooks reagirem em runtime (mesma aba).
  // window.storage só dispara em OUTRAS abas.
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('sixpass:checkin-done'));
  }
}

/** True se já fez pelo menos 1 check-in no dia local atual. */
export function hasCheckinToday(): boolean {
  return safeGet(KEY) === todayLocalISO();
}

/**
 * Remove o flag de "fez check-in hoje". Chamado quando o user CANCELA o
 * check-in (Scanner handleCancelCheckin) — sem isso, o Daily Bonus B
 * continuaria liberando épico/lendário mesmo após o cancelamento.
 */
export function clearCheckinDoneToday(): void {
  safeRemove(KEY);
  if (typeof window !== 'undefined') {
    // Dispara o mesmo evento que markCheckinDoneToday, mas a função
    // hasCheckinToday() agora vai retornar false. Hooks re-recomputam.
    window.dispatchEvent(new CustomEvent('sixpass:checkin-done'));
  }
}
